<template>
    <div class="pagination__wrap">
        <div class="pagination">
            <a class="pagination__link pagination__link--prev" :class="{'pagination__link--hidden': dataPag.prev_page_url === null}" @click="getPrevPage()">
                Previous
            </a>
			<ul class="pagination__list">
				<template v-for="(item, index) in arrayStart">
					<li class="pagination__list-item" :class="{'is-active': dataPag.current_page === item}" :key="'0'+index">
						<a v-if="isNaN(item)" class="pagination__list-item-link">
							{{item}}
						</a>
						<a v-else class="pagination__list-item-link pagination__list-item-link--num" @click="getPage(item)">
							{{item}}
						</a>
					</li>
				</template>
				<template v-for="(item, index) in arrayMid">
					<li class="pagination__list-item" :class="{'is-active': dataPag.current_page === item}" :key="'1'+index">
						<a v-if="isNaN(item)" class="pagination__list-item-link">
							{{item}}
						</a>
						<a v-else class="pagination__list-item-link pagination__list-item-link--num" @click="getPage(item)">
							{{item}}
						</a>
					</li>
				</template>
				<template v-for="(item, index) in arrayEnd">
					<li class="pagination__list-item" :class="{'is-active': dataPag.current_page === item}" :key="'2'+index">
						<a v-if="isNaN(item)" class="pagination__list-item-link">
							{{item}}
						</a>
						<a v-else class="pagination__list-item-link pagination__list-item-link--num" @click="getPage(item)">
							{{item}}
						</a>
					</li>
				</template>
			</ul>
            <a class="pagination__link pagination__link--next" :class="{'pagination__link--hidden': dataPag.next_page_url === null}" @click="getNextPage()">
                Next
            </a>
        </div>
    </div>
</template>

<script>
export default {
	data() {
		return {
			filter: [],
			dataPag: {
				current_page: '',
				first_page_url: '',
				from: '',
				last_page: '',
				last_page_url: '',
				links: [],
				next_page_url: '',
				per_page: '',
				prev_page_url: '',
				status: '',
				to: '',
				total: ''
			},
			arrayStart: [],
			arrayMid: [],
			arrayEnd: []
		};
	},
	methods: {
		getPrevPage() {
			const str = this.dataPag.prev_page_url;
			if (str) {
				const page = str.split('=')[1];
				this.$emit('getPage', page, this);
			}
		},
		getNextPage() {
			const str = this.dataPag.next_page_url;
			if (str) {
				const page = str.split('=')[1];
				this.$emit('getPage', page, this);
			}
		},
		getPage(index) {
			const page = index;
			this.$emit('getPage', page, this);
		},
		pagination() {
			this.arrayStart = [];
			this.arrayMid = [];
			this.arrayEnd = [];
			const dots = '...';
			const end = this.dataPag.last_page - 2;
			const currPage = this.dataPag.current_page;
			const totalPages = this.dataPag.last_page;

			if (currPage > 4) {
				this.arrayStart.push(1);
				this.arrayStart.push(dots);
			} else {
				if (currPage === 4) {
					this.arrayStart.push(1);
					this.arrayStart.push(2);
					this.arrayStart.push(3);
				} else if (currPage === 3) {
					this.arrayStart.push(1);
					this.arrayStart.push(2);
				} else if (currPage === 2) {
					this.arrayStart.push(1);
				}
			}

			if (currPage > 4) {
				this.arrayMid.push(currPage - 2);
				this.arrayMid.push(currPage - 1);
			}
			this.arrayMid.push(currPage);
			if (currPage < end) {
				this.arrayMid.push(currPage + 1);
				this.arrayMid.push(currPage + 2);
			}

			if (currPage < end) {
				this.arrayEnd.push(dots);
				this.arrayEnd.push(totalPages);
			} else {
				if (currPage === end) {
					this.arrayEnd.push(totalPages - 1);
					this.arrayEnd.push(totalPages);
				} else if (currPage === totalPages - 2) {
					this.arrayEnd.push(totalPages);
				} else if (currPage === totalPages - 1) {
					this.arrayEnd.push(totalPages);
				}
			}
		},
		updateDataPag(data) {
			this.dataPag = {
				current_page: data.current_page,
				first_page_url: data.first_page_url,
				from: data.from,
				last_page: data.last_page,
				last_page_url: data.last_page_url,
				links: data.links,
				next_page_url: data.next_page_url,
				per_page: data.per_page,
				prev_page_url: data.prev_page_url,
				status: data.status,
				to: data.to,
				total: data.total
			};
			this.pagination();
		}
	}
};
</script>

<style lang="scss" scoped>
.pagination {
	display: flex;
	align-items: center;
}

.pagination__wrap {
    width: 100%;
    max-width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 10px;
	margin-bottom: 20px;
}

.pagination__link {
	cursor: pointer;
	font-size: 14px;
	color: $fiord;
	position: relative;
	transition: $dur $ease;

	@include mq($sm) {
		font-size: 12px;
	}

	@include hover {
		text-decoration: none;
		&::before {
			transform: scale(0);
			opacity: 0;
		}
	}

	&::before {
		content: '';
		background-color: $grey-mid;
		height: 1px;
		width: 100%;
		display: inline-block;
		position: absolute;
		bottom: 0;
		left: 0;
		transition: $dur $ease;
		opacity: 1;
	}

	&--hidden {
		opacity: 0;
		pointer-events: none;
	}

    &--prev {
        margin-right: 20px;

		@include mq($sm) {
			margin-right: 5px;
		}
    }

    &--next {
        margin-left: 20px;

		@include mq($sm) {
			margin-left: 5px;
		}
    }
}

.pagination__list {
	display: flex;
	margin-bottom: 0;
}

.pagination__list-item {
	margin: 0 5px;
	width: 28px;
	height: 28px;
	display: flex;
	justify-content: center;
	align-items: center;
	background-color: $white;
	transition: $dur $ease;
	position: relative;
	border-radius: 50%;

	@include mq($sm) {
		height: 21px;
		width: 21px;
	}

	@include hover {
		.pagination__list-item-link--num::before {
			border: 1px solid $fiord;
		}
	}

	&.is-active {
		background-color: $fiord;

		.pagination__list-item-link {
			color: $white;
		}
	}
}

.pagination__list-item-link {
	font-size: 14px;
	font-weight: 600;
	color: $shuttle-gray;
	transition: $dur $ease;
	z-index: 1;
	padding: 4px 5px;
	text-align: center;
	width: 28px;
	height: 28px;
	cursor: default;

	@include mq($sm) {
		width: 20px;
		height: 20px;
		padding: 0;
	}

	&:hover {
		text-decoration: none;
	}
}

.pagination__list-item-link--num {
	position: relative;
	cursor: pointer;

	&::before {
		content: '';
		width: 28px;
		height: 28px;
		position: absolute;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);
		border: 1px solid transparent;
		transition: $dur $ease;
		border-radius: 50%;

		@include mq($sm) {
			height: 20px;
			width: 20px;
		}
	}
}
</style>
